import React from 'react';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'default' | 'destructive' | 'outline' | 'secondary' | 'ghost';
  size?: 'default' | 'sm' | 'lg';
  children: React.ReactNode;
}

export function Button({ 
  children, 
  variant = 'default', 
  size = 'default', 
  className = '',
  ...props 
}: ButtonProps) {
  const base = 'inline-flex items-center justify-center rounded-md font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--brand-focus-ring)] focus-visible:ring-offset-2 focus-visible:ring-offset-[var(--brand-surface-app)] disabled:opacity-50 disabled:pointer-events-none';
  
  const variants: Record<string, string> = {
    default: 'bg-[var(--brand-btn-primary-bg)] text-[var(--brand-btn-primary-text)] hover:bg-[var(--brand-btn-primary-bg-hover)]',
    destructive: 'bg-[var(--brand-status-danger)] text-[var(--brand-text-inverse)] hover:bg-[var(--brand-status-danger)]',
    outline: 'border border-[var(--brand-btn-outline-border)] bg-transparent hover:bg-[var(--brand-surface-hover)] text-[var(--brand-text-primary)]',
    secondary: 'bg-[var(--brand-btn-secondary-bg)] text-[var(--brand-btn-secondary-text)] hover:bg-[var(--brand-btn-secondary-bg-hover)]',
    ghost: 'text-[var(--brand-text-secondary)] hover:bg-[var(--brand-btn-ghost-hover)] hover:text-[var(--brand-text-primary)]',
  };

  const sizes: Record<string, string> = {
    default: 'h-10 px-4 py-2',
    sm: 'h-8 px-3 text-sm',
    lg: 'h-12 px-8 text-lg',
  };

  return (
    <button
      className={`${base} ${variants[variant]} ${sizes[size]} ${className}`}
      {...props}
    >
      {children}
    </button>
  );
} 
